import React from 'react'
import styled from 'styled-components'
// icons
import Responsive from '../assets/config/Responsive'
import AppStoreBtn from './v2/AppStoreBtn'
import PlayStoreButton from './v2/PlayStoreBtn'

const PlayStores: React.FC<{
  style?: React.CSSProperties
}> = ({ style }) => {
  return (
    <Wrapper style={style}>
      <PlayStoreButton appId="com.frani.twa" />
      <AppStoreBtn appId="#" />
    </Wrapper>
  )
}
//styles
const Wrapper = styled.div`
  position: relative;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;

  /* box shadow */
  box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.02);
  -webkit-box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.02);
  -moz-box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.02);

  /* responsive */
  ${Responsive.tablet} {
    width: 100%;
    gap: 20px;
  }
  ${Responsive.mobile} {
    width: 100%;
    padding: 45px 0px;
    background-image: none;
    gap: 20px;
  }
`

export default PlayStores
